<template>
  <div>
  <!--begin::Advance Table Widget 10-->
  <div class="card card-custom gutter-b">
    <!--begin::Header-->

    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{ $t('TRANSLATOR.OVERVIEWLINE', { msg: 'OVERVIEWLINE' }) }} {{ lineId }}</span>
      <span class="text-muted mt-3 font-weight-bold font-size-sm">Conveyors : {{ lineInfo.length }}<br>
        Components : {{ getTotalGreen + getTotalOrange + getTotalRed }}</span>
      </h3>
      <div class="card-toolbar">
        <b-button class="mb-3"
          @click="submit('green')"
          :class="active == 'green' ? ' active' : ''"
          variant="success"
          >{{ $t('TRANSLATOR.GREEN') }}</b-button>
        <b-button class="mb-3"
          @click="submit('orange')"
          :class="active == 'orange' ? ' active' : ''"
          variant="warning"
          >{{ $t('TRANSLATOR.ORANGE') }}</b-button>
        <b-button class="mb-3"
          @click="submit('red')"
          :class="active == 'red' ? ' active' : ''"
          variant="danger"
          >{{ $t('TRANSLATOR.RED') }}</b-button>
        <b-button class="mb-3" @click="submit('all')">{{ $t("TRANSLATOR.CLEAR", { msg: "CLEAR" }) }}</b-button>
      </div>
    </div>
    <div class="card-body py-0 pb-5">
      <b-row>
        <b-col md="6" class="text-center">
          <b-row>
            <b-col md="12" class="text-center">
              <b-alert :show="responseStatus == 200" dismissible fade variant="success">
                PDF Uploaded {{ this.responseText }}
              </b-alert>
              <b-form-file id="fileUpload" class="w-75" v-model="headerpdffile" :placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')"
                :drop-placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')" accept="application/pdf" @change="onFilePdfChange" style="display: none;"></b-form-file>
              <a v-if="pdfurl" class="w-75 btn btn-secondary font-weight-bolder font-size-sm"
              href="javascript:;"
              disabled
              v-b-tooltip.hover.top="$t('TRANSLATOR.OPEN_PDF')">
              <span class="svg-icon svg-icon-lg svg-icon-primary">
                  <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
              </span>
                {{ pdfurl }}
              <span class="mb-3 text-danger" v-if="isPdfSize == true"><br />File size exceeds 5 MB </span>
              </a>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="text-center">
                <b-button type="reset" class="mt-3 w-100" size="md" @click="reset" v-if="headerpdffile">{{ $t('TRANSLATOR.CLEAR') }}</b-button>
            </b-col>
            <b-col md="6" class="text-center">
                <b-button type="submit" class="mt-3 mb-3 w-100" variant="primary" size="md" @click="UploadHeaderPdf" v-if="headerpdffile">{{ $t('TRANSLATOR.UPLOAD') }}</b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" class="text-right">
          <a v-if="fullPdfurl" class="btn btn-secondary font-weight-bolder font-size-sm mr-5"
          v-b-tooltip.hover.top="$t('TRANSLATOR.OPEN_PDF')"
          v-b-modal.modal-pdf-viewer
          >
          <span class="svg-icon svg-icon-lg svg-icon-primary">
              <inline-svg src="media/svg/icons/Files/Selected-file.svg" />
          </span>
            {{ $t('TRANSLATOR.OPEN_PDF') }}
          </a>
          <span class="svg-icon svg-icon-lg svg-icon-primary" @click="chooseFiles()" v-b-tooltip.hover.top="$t('TRANSLATOR.UPLOAD_PDF')" style="cursor: pointer;">
            <inline-svg src="media/svg/icons/Files/File-plus.svg" />
          </span>
          <span class="mb-3 text-warning mt-3" v-if="headerpdffile && pdfurl"><br /><br /> This PDF will be overwritten with the new upload </span>
          <!-- <b-alert :show="headerpdffile && pdf" dismissible variant="warning" class="mt-3"> -->
            
          <!-- </b-alert> -->
        </b-col>
        <!-- <b-col md="3" class="text-center">
        </b-col> -->
      </b-row>
    </div>

    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body py-0">
      <b-progress
        :max="getTotalGreen + getTotalOrange + getTotalRed"
        show-value
      >
        <b-progress-bar
          :value="getTotalGreen"
          variant="success"
        ></b-progress-bar>
        <b-progress-bar
          :value="getTotalOrange"
          variant="warning"
        ></b-progress-bar>
        <b-progress-bar :value="getTotalRed" variant="danger"></b-progress-bar>
      </b-progress>
      <!--begin::Table-->
      <div class="table-responsive">
        <table
          class="table table-head-custom table-vertical-center"
          id="kt_advance_table_widget_4"
        >
          <thead>
            <tr class="text-left">
              <th class="pl-0 pb-15" style="width: 55px">
                <span class="pl-4">{{ $t('TRANSLATOR.STATUS') }}</span></th>
              <th style="min-width: 65px; max-width: 90px">
                <span class="pl-4">Nr</span>
                  <b-form-input
                    id="input-2"
                    v-model="form.conveyorNumber"
                    v-on:keyup="(e) => FilterDataConveyorNumber(e.target.value)"
                    placeholder="Ex : 1"
                  ></b-form-input>
              </th>
              <th style="min-width: 140px">
                <span class="pl-4">Conveyor</span>                
                  <b-form-input
                    id="input-2"
                    v-model="form.name"
                    v-on:keyup="(e) => FilterDataName(e.target.value)"
                    placeholder="Search by conveyor..."
                  ></b-form-input>
              </th>
              <th style="min-width: 100px">
                <span class="pl-4">{{ $t("TRANSLATOR.SECTION", { msg: "SECTION" }) }}</span>                
                <b-form-input
                  id="input-2"
                  v-model="form.sortOrder"
                  v-on:keyup="(e) => FilterDataSection(e.target.value)"
                  placeholder="Search by section..."
                ></b-form-input>
              </th>
              <!-- <th style="min-width: 60px; max-width: 120px">Code</th> -->
              <!-- <th class="pr-0 text-right" style="min-width: 60px; max-width: 75px">Length</th> -->
              <th class="pr-10" style="min-width: 100px">
                <span class="pl-4">{{ $t("TRANSLATOR.LASTCHECK", { msg: "LASTCHECK" }) }}</span>            
                <b-form-input
                  id="input-2"
                  v-model="form.updated"
                  v-on:keyup="(e) => FilterDataUpdated(e.target.value)"
                  placeholder="Search by date..."
                ></b-form-input>
              </th>
              <!-- <th class="pr-0 text-right" style="min-width: 60px; max-width: 100px">Status</th> -->
              <th
                class="pl-0 text-center"
                style="min-width: 20px; max-width: 40px"
              >
                <span class="label label-lg label-inline label-light-success">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Navigation/Check.svg" />
                  </span>
                </span>
              </th>
              <th
                class="pl-0 text-center"
                style="min-width: 20px; max-width: 40px"
              >
                <span class="label label-lg label-inline label-light-warning">
                  <span class="svg-icon">
                    <inline-svg
                      src="media/svg/icons/Code/warning-1-circle.svg"
                    />
                  </span>
                </span>
              </th>
              <th
                class="pl-0 text-center"
                style="min-width: 20px; max-width: 40px"
              >
                <span class="label label-lg label-inline label-light-danger">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Code/Warning-2.svg" />
                  </span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in lineInfo">
              <tr v-bind:key="i">
                <td class="pl-0 pl-4">
                  <span
                    v-if="item.statusRed === 0 && item.statusOrange === 0"
                    class="label label-lg label-inline label-light-success"
                  >
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Navigation/Check.svg" />
                    </span>
                  </span>
                  <span
                    v-if="item.statusRed === 0 && item.statusOrange > 0"
                    class="label label-lg label-inline label-light-warning"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="media/svg/icons/Code/warning-1-circle.svg"
                      />
                    </span>
                  </span>
                  <span
                    v-if="item.statusRed > 0"
                    class="label label-lg label-inline label-light-danger"
                  >
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Code/Warning-2.svg" />
                    </span>
                  </span>
                </td>
                <td class="pr-0 pl-7">
                  <a
                    v-bind:href="`#/line/${lineId}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >
                    {{ item.lineNumber }} > {{ item.conveyorNumber }}
                  </a>
                </td>
                <td class="pr-0 pl-7">
                  <a
                    v-bind:href="`#/line/${lineId}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >{{ item.conveyorExtName }}
                  </a>
                </td>
                <td class="pr-0 pl-7">
                  <a
                    v-bind:href="`#/line/${lineId}/conveyor/${item.conveyorNumber}`"
                    class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                  >
                    <!-- <span class="text-grey font-weight-bolder d-block font-size-lg"> -->
                    <!-- {{ item.conveyorName }} -->
                    {{ item.sortOrder }}
                    <!-- </span> -->
                  </a>
                </td>
                <!-- <td>
                  <span class="text-muted font-weight-bold">{{item.code}}</span>
                </td> -->
                <!-- <td class="pr-0 text-right">
                  <span class="text-muted font-weight-bold">{{item.length}} m</span>
                </td> -->
                <td class="pr-0 pl-7">
                  <span class="text-muted font-weight-bold">{{
                    item.updated
                  }}</span>
                </td>
                <td class="text-center">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                  </span>
                  <span class="text-muted font-weight-bold">{{
                    item.statusGreen
                  }}</span>
                </td>
                <td class="text-center">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                  </span>
                  <span class="text-muted font-weight-bold">{{
                    item.statusOrange
                  }}</span>
                </td>
                <td class="text-center">
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  >
                  </span>
                  <span class="text-muted font-weight-bold">{{
                    item.statusRed
                  }}</span>
                </td>
                <!-- <td class="pr-0 text-right">
                  <span class="label label-lg label-inline" v-bind:class="`label-light-${item.class}`">{{ item.status }}</span>
                </td> -->
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
    </div>

    <!-- Start of loading animation -->
    <div class="mt-40" v-if="loading">
      <p class="text-6xl font-bold text-center text-gray-500 animate-pulse">
        Loading...
      </p>
    </div>
    <!-- End of loading animation -->
    <!-- Start of error alert -->
    <div class="mt-12 bg-red-50" v-if="error">
      <h3 class="px-4 py-1 text-4xl font-bold text-white bg-red-800">
        {{ error.title }}
      </h3>
      <p class="p-4 text-lg font-bold text-red-900">{{ error.message }}</p>
    </div>
    <!-- End of error alert -->
    <!--end::Body-->
  </div>
    <div>
      <b-modal id="modal-pdf-viewer" :title="this.fullPdfurl" size="xl" scrollable>
        <b-row>
          <b-col md="6" class="text-left">
            <a class="btn btn-primary font-size-sm ml-3" @click="page--" :class="page < 2 ? ' disabled' : ''" v-if="pageCount > 1">
              <span class="svg-icon svg-icon-md svg-icon-white">
                <inline-svg src="media/svg/icons/Media/Backward.svg" />
            </span>{{ $t('TRANSLATOR.PREV') }}</a>
            <a class="btn btn-primary font-size-sm ml-3" @click="page++" :class="page >= pageCount ? ' disabled' : ''" v-if="pageCount > 1">
              <span class="svg-icon svg-icon-md svg-icon-white ">
                <inline-svg src="media/svg/icons/Media/Forward.svg" />
            </span>{{ $t('TRANSLATOR.NEXT') }}</a>
            <!-- <b-button type="submit" class="ml-3" size="sm" @click="page--" :disabled="page < 2">{{ $t('TRANSLATOR.PREV') }}</b-button> -->
            <!-- <b-button type="submit" class="ml-3" size="sm" @click="page++" :disabled="page >= pageCount">{{ $t('TRANSLATOR.NEXT') }}</b-button> -->
            <a :href="`media/upload/${this.fullPdfurl}`" target="_blank" class="btn btn-primary font-size-sm ml-3" v-b-tooltip.hover.top="$t('TRANSLATOR.MORE_PDF')">
              <span class="svg-icon svg-icon-md svg-icon-white">
                <inline-svg src="media/svg/icons/Design/ZoomPlus.svg" />
            </span>More</a>
          </b-col>
          <b-col md="6" class="text-right">
            <span v-if="pageCount > 1">{{currentPage}} / {{pageCount}}</span>
          </b-col>
        </b-row>
        <pdf
          :src="`media/upload/${this.fullPdfurl}`"
          :page="page"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
          v-disable-right-click
          class="mt-3"
        ></pdf>
      </b-modal>
    </div>
  </div>
  <!--end::Advance Table Widget 10-->
</template>

<script>
import axios from "axios";
import JwtService from "@/core/services/jwt.service";
import pdf from 'vue-pdf';
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "widget-1",
  props: {
    lineId: String,
    // value: String
  },
  directives: {
    'disable-right-click': {
      // Directive definition
      bind: function(el) {
        el.addEventListener('contextmenu', function(event) {
          event.preventDefault(); // Prevent the default context menu behavior
        });
      }
    }
  },
  data() {
    return {
      checked: false,
      loading: false,
      active: "",
      error: null,
      lineInfo: [],
      filterData: [],
      greenData: [],
      redData: [],
      orangeData: [],
      filterName: "5",
      selected: null,
      // UPLOAD
      submitted: false,
      headerpdffile: null,
      userId: JwtService.authorizeToken().id,
      userName: JwtService.authorizeToken().name,
      userEmail: JwtService.authorizeToken().emailaddress,
      companyId: JwtService.authorizeToken().companyId,
      isAdmin: JwtService.authorizeToken().isAdmin,
      isPdfSize: false,
      pdfurl: null,
      fullPdfurl: null,
      dismissSecs: 10,
      dismissCountDown: 0,
      pdf: false,
      responseData: null,
      responseStatus: null,
      responseText: null,
      // END UPLOAD
			currentPage: 0,
			pageCount: 0,
      page: 1,
      options: [
        { value: null, text: "Filter data" },
        { value: "red", text: "Red" },
        { value: "green", text: "Green" },
        { value: "orange", text: "Orange" },
      ],
      form: {
        name: "",
        conveyorNumber: "",
        sortOrder: "",
        updated: "",
      },
    };
  },
  computed: {
    getTotalOrange() {
      const total = this.lineInfo.reduce((sum, object) => {
        sum += object.statusOrange;
        return sum;
      }, 0);
      return total;
    },
    getTotalRed() {
      const total = this.lineInfo.reduce((sum, object) => {
        sum += object.statusRed;
        return sum;
      }, 0);
      return total;
    },
    getTotalGreen() {
      const total = this.lineInfo.reduce((sum, object) => {
        sum += object.statusGreen;
        return sum;
      }, 0);
      return total;
    },
  },
  components: {
    pdf,
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    getStatusClass: (status) => {
      switch (status) {
        case "red":
          return "danger";
        case "orange":
          return "warning";
        case "green":
          return "success";
      }
    },
    goToHome(type) {
      if (type == "next") {
        this.lineId++;
        //  this.lineId = this.lineId + 1
      } else {
        this.lineId--;
        // this.lineId = this.lineId - 1
      }
      this.lineId = this.lineId;
      // console.log(this.lineId);
      this.$router.push("/line/" + this.lineId);

      axios
        .get("/line/" + this.lineId)
        .then((response) => {
          this.lineInfo = response.data;
          this.filterData = response.data;
          // console.log(this.lineInfo)
          // this.getTotal();
        })
        .catch((err) => {
          throw err;
        });
    },

    FilterDataName: function (e) {
      if (e.length >= 1) {
        let newData = this.filterData.filter(
          (item) =>
            item.conveyorExtName.toLowerCase().includes(e)
        );
        this.lineInfo = newData;
        this.form.conveyorNumber = "";
        this.form.sortOrder = "";
        this.form.updated = "";
      }
      if (e.length == 0) {
        this.lineInfo = this.filterData;
      }
    },
    FilterDataSection: function (e) {
      if (e.length >= 1) {
        let newData = this.filterData.filter(
          (item) =>
            item.sortOrder.toLowerCase().includes(e)
        );
        this.lineInfo = newData;
        this.form.name = "";
        this.form.conveyorNumber = "";
        this.form.updated = "";
      }
      if (e.length == 0) {
        this.lineInfo = this.filterData;
      }
    },
    FilterDataConveyorNumber: function (e) {
      if (e.length >= 1) {
        let newData = this.filterData.filter(
          (item) =>
            item.conveyorNumber == e
        );
        this.lineInfo = newData;
        this.form.name = "";
        this.form.sortOrder = "";
        this.form.updated = "";
      }
      if (e.length == 0) {
        this.lineInfo = this.filterData;
      }
    },
    FilterDataUpdated: function (e) {
      if (e.length >= 1) {
        // console.log(this.lineInfo)
        let newData = this.filterData.filter(
          (item) =>
            item.updated.toLowerCase().includes(e)
        );
        this.lineInfo = newData;
        this.form.name = "";
        this.form.conveyorNumber = "";
        this.form.sortOrder = "";
      }
      if (e.length == 0) {
        this.lineInfo = this.filterData;
      }
    },
    submit: function (e) {
      this.active = e;
      if (e == "red") {
        let newData = this.filterData.filter((item) => item.statusRed > 0);
        this.lineInfo = newData;
      }
      if (e == "orange") {
        let newData = this.filterData.filter(
          (item) => item.statusRed === 0 && item.statusOrange > 0
        );
        this.lineInfo = newData;
      }
      if (e == "green") {
        let newData = this.filterData.filter(
          (item) => item.statusRed === 0 && item.statusOrange === 0
        );
        this.lineInfo = newData;
      }
      if (e == "all") {
        this.lineInfo = this.filterData;
      }
    },
    reset: function() {
      this.headerpdffile = null;
      this.pdfurl = null;
      this.isPdfSize = false;
    },
    onFilePdfChange(e) {
      const file = e.target.files[0];
      // this.pdfurl = URL.createObjectURL(file);
      this.pdfurl = file.name.toString().replaceAll(' ', '-').split('.').join('-').toLowerCase().substr(0, file.name.lastIndexOf('.'));
      if (file.size >= '5242880') {
        this.isPdfSize = true
        return;
      } else {
        this.isPdfSize = false
      }
    },
    async UploadHeaderPdf() {
      let formData = new FormData();

      if (this.headerpdffile != null) {
        if (this.headerpdffile.size >= '5242880') {
          this.isPdfSize = true
          return;
        } else {
          this.isPdfSize = false
        }
        // formData.append("file", this.headerpdffile);

        const FileName = this.headerpdffile.name.toString().replaceAll(' ', '-').split('.').join('-').toLowerCase().substr(0, this.headerpdffile.name.lastIndexOf('.'));
        // console.log(FileName);
        // const FileName = "line-" + this.lineId;
        const photoUrl = URL.createObjectURL(this.headerpdffile);
        const image = new Image();
        // const imageDimensions = await new Promise((resolve) => {
          // image.onload = () => {
          //   const dimensions = {
          //     height: image.height,
          //     width: image.width,
          //   };
          //   resolve(dimensions);
          // };
          image.src = photoUrl;
        // });
        var extension = this.headerpdffile.name.substr(this.headerpdffile.name.lastIndexOf('.') + 1);
        formData.append("file", this.headerpdffile);
        formData.append("FileName", FileName);
        formData.append("extension", extension);
      }
        formData.append("LineNumber", this.lineId);
        formData.append("CompanyId", this.companyId);
        formData.append("UserId", this.userId);
        formData.append("conveyorId", 0);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
       
      this.submitted = true;
      
      // Execute Update Conveyor Status
      axios
        .post("line/UploadLinePDF", formData, config
        )
        .then((response) => {
          // console.log(response);
          this.responseData = response.data; // Returned data
          this.responseStatus = response.status; // 200
          this.responseText = response.statusText; // OK
          this.dismissCountDown = this.dismissSecs;
          this.headerpdffile = null;
          // Reload page with new status
          // this.$emit("statusChange");
          window.location.reload(true);
        })
        .catch((err) => {
          throw err;
        });
    },
    chooseFiles() {
        document.getElementById("fileUpload").click()
    },
  },
  mounted() {
    this.$root.$on("BrowserCallBack", () => {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `Home > Line ${this.lineId}`,
          route: `/home/`,
        },
      ]);  
    }),
    // this.fetchLineInfo();
    axios
      .get("/line/" + this.lineId)
      .then((response) => {
        this.lineInfo = response.data;
        this.filterData = response.data;
        
        axios
          .get("/line/" + this.lineId + "/GetPdf-0")
          .then((response) => {
            this.fullPdfurl = response.data;
            // console.log(this.pdf);
          })
          .catch((err) => {
            throw err;
          });
          
      })
      .catch((err) => {
        throw err;
      });
  },
};
</script>
